import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

async function registerAcademy(payload) {
  const response = await apiClient.post("/api/v1/onboarding/academies/", payload);
  return response.data;
}

function useRegisterAcademy() {
  return useMutation({ mutationFn: registerAcademy });
}

export { useRegisterAcademy };
